export default __webpack_public_path__ + "static/media/SndLowerKKick.377e8316.mp3";